import { doc, getFirestore } from 'firebase/firestore';
import FirebaseDoc from '../../../abstract/FirebaseDoc';

class EpcState extends FirebaseDoc {
  constructor(root) {
    super(root, {
      ref: doc(getFirestore(), `properties/${root.id}/data/epc`),
    });
  }
}

EpcState.annotations = {
  ...FirebaseDoc.annotations,
};

export default EpcState;
